import { render, staticRenderFns } from "./WDesktopLive.vue?vue&type=template&id=19f4f634&scoped=true&"
import script from "./WDesktopLive.vue?vue&type=script&lang=js&"
export * from "./WDesktopLive.vue?vue&type=script&lang=js&"
import style0 from "./WDesktopLive.vue?vue&type=style&index=0&id=19f4f634&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f4f634",
  null
  
)

/* custom blocks */
import block0 from "./WDesktopLive.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VLayout})
